import Vue from 'vue'
import Vuex from 'vuex'
import axiosIns from '../libs/axios'

Vue.use(Vuex)


export default new Vuex.Store({
    state: { //khai báo biến
        appSettings: {
            "start_with": {
                "type": "form_input",
                configs: {
                    form_input: [],
                    ican_connect: {}
                }
            },
            fb_tracking: '',
            theme: ''
        },
        page: 1,
        tracking_id: null,
        examData: null,
        examId: null,
        contactInfo: {},
        loading: false,
        questionProcess: {
            questionCount: 0,
            questionCurrent: 0
        },
        sectionName: '',
        examTime: 0,
        testHistoryData: {}
    },
    getters: {
        getQuestion(state) {
            return state?.examData
        },
        getThemeSetting (state) {
            return state?.appSettings?.theme || 'blank'
        },
        getStartWith (state) {
            return state.appSettings?.start_with?.configs
        },
        getContactInfo(state) {
            return state.contactInfo
        }
    },
    mutations: { // thực hiện commit của action
        SET_CONTACT_INFO(state, payload) {
            state.contactInfo = payload
        },
        
        SET_PAGE(state, payload) {
            state.page = payload;
        },
        SET_PART(state, payload) {
            state.part = payload
        },
        SET_TRACKING_ID(state, payload) {
            state.tracking_id = payload
        },
        SET_QUESTIONS(state, payload) {
            console.log(payload)
            state.examData = payload.examData,
            state.examId = payload.id
            state.examTime = 600
        },
        SET_EXAM_TIME(state, payload) {
            state.examTime = payload
        },
        PAGE_LOADING(state, payload) {
            state.loading = payload
        },
        PAGE_PROCESS(state, payload) {
            state.questionProcess = payload
        },
        SET_SECTION_NAME(state, payload) {
            state.sectionName = payload
        },
        SET_TEST_HISTORY(state, payload) {
            state.testHistoryData = payload
        },
        SET_SETTINGS(state, settings) {
            state.appSettings = settings
        },
    },
    actions: { // tạo 1 action
        
        saveContact ({commit}, payload) {
            localStorage.setItem('_speakup_user', payload)
            commit('SET_CONTACT_INFO', JSON.parse(payload))
        },
        Tracking_init({ commit, state }) {
            const tracking = localStorage.getItem('_speakup_track')

            if (tracking) {
                commit('SET_TRACKING_ID', tracking)
            } else {
                axiosIns.get('/track/init', {
                    params: {
                        tracking_id: state.tracking_id
                    }
                })
                .then(res => {
                    if (res.data.code === 1) {
                        localStorage.setItem('_speakup_track', res.data.data)
                        commit('SET_TRACKING_ID', res.data.data)
                    }
                })
            }
        },
        getQuestion ({ commit, state }) {
            axiosIns.get('/get-questions', {
                params: {
                    tracking_id: state.tracking_id,
                }
            }).then(res => {
                if (res.data.code == 1) {
                    commit('SET_QUESTIONS', res.data.data)
                }
            })
        },

        pageSetting ({ commit }) {
            return new Promise((resolve, reject) => {
                axiosIns.get('/site/config')
                .then(res => {
                    commit('SET_SETTINGS', res.data)

                    return resolve(true)
                })
                .catch(err => {
                    reject(err)
                })
            })    
        },
    },
    modules: {
        // auth: moduleAuth,
        // campaign: modulCampaign
    },
    strict: process.env.NODE_ENV !== 'production'
})
